import { PageModule } from './PageModule';
import { RouterModule } from './RouterModule';
import { HistoryModule } from './HistoryModule';
import { DomLoader } from '../../loader/DomLoader';
import Module from './Module';

function rtrim(str, chars) {
    chars = chars || "\\s";
    return str.replace(new RegExp("[" + chars + "]+$", "g"), "");
};
/**
 * 
 * @extends Module
 * @category bootstrap
 * @author Geoffrey Mayeux
 */

class AjaxPageModule extends Module{
	constructor(bootstrap){
		super(bootstrap);

		this.dependencies.add(PageModule);
		this.dependencies.add(RouterModule);

		this.loader 	= new DomLoader();
		this.prepend 	= true;

		this._current = null;

		this.transform = async (dom) => dom;
	}

	get priority(){
		return 1;
	}

	get pageModule(){
		return this.bootstrap.get(PageModule);
	}

	async run(){
		let current = this.pageModule.current;
		let router 	= this.bootstrap.get(RouterModule).router;
		let url 	= router.current.toString();

		if(!router.previous)
			this._current = url;

		if(current && router.previous && rtrim(this._current, '/') != rtrim(url, '/')){
			await this.loader.load(url);

			let dom = this.loader.get(url);
			if(dom){
				dom = await this.transform(dom);
				this.loader.delete(url);
				this.insertElement(dom);
				this.pageModule.current = dom;
				this._current = url;
			}
		}
	}

	insertElement(element){
		if(element){
			if(this.prepend){
				if(element instanceof NodeList){
					element.forEach(item => this.pageModule.root.insertBefore(item, this.pageModule.root.firstChild));
				}
				else this.pageModule.root.insertBefore(element, this.pageModule.root.firstChild);
			}
			else{
				if(element instanceof NodeList){
					element.forEach(item => this.pageModule.root.appendChild(item));
				}
				else this.pageModule.root.appendChild(element);
			}
		}
	}
}

export default AjaxPageModule;
export { AjaxPageModule };